$(document).ready(function () {
  $('.specialSlider').slick({
    arrows: true,
    dots: true,
    responsive: [{
      breakpoint: 480,
      settings: {
        arrows: false,
      }
    }]
  });
  $('#exitbutton').click(function () {
    $.get("http://usuarios.larepublica.co:5000/api/logout", function (data) {});
  });

  $(function () {
    $("[quote-tab-group]").each(function (idx, el) {
      $(el).find('ul.tabs li:first').addClass('active');
      $(el).find('.block .tab').hide();
      $(el).find('.block .tab:first').show();
      $(el).removeClass('hide-quote');
      $(el).find('ul.tabs li').on('click', function () {
        $(el).find('ul.tabs li').removeClass('active');
        $(this).addClass('active')
        $(el).find('.block .tab').hide();
        $($(this).find('a').attr('href')).show();
        return false;
      });
      $(el).find('ul.md-tabs li:first').addClass('active');
      $(el).find('.block .md-tab').hide();
      $(el).find('.block .md-tab:first').show();
      $(el).find('ul.md-tabs li').on('click', function () {
        $(el).find('ul.md-tabs li').removeClass('active');
        $(this).addClass('active')
        $(el).find('.block .md-tab').hide();
        var activeTab = $(this).find('a').attr('href');
        $(activeTab).show();
        for (var graph in graphics) {
          graphics[graph].resize();
        }
        return false;
      });
    });
  });

});